import { Heading, Loader } from "@/components";
import { AlertCircle, Ban, CheckCircle2 } from "lucide-react";
import { Badge } from "@/components/ui";
import useFiscalYearClosing from "./useFiscalYearClosing";
import { Actions, AuditLog, FinancialHealth, ValidationCockpit } from "@/pages";

const FiscalYearClosing = () => {
  const {isLocked, isFiscalDataLoading, breadcrumbTitle, breadcrumbData, fiscalYear, setIsValidationCompleted, isValidationCompleted} = useFiscalYearClosing();

  return (
    <div className="p-4 md:p-6 !pt-6">
      {/* Header */}
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between sticky top-[10px] z-10 bg-g-10 pb-4">
        <Heading
          title={breadcrumbTitle}
          breadcrumbData={breadcrumbData}
        />
        <div className="flex flex-wrap items-center gap-6">
          <span className="text-xl sm:text-2xl font-bold text-primary">
            {fiscalYear}
          </span>

          {isLocked ? (
            <Badge className="px-4 py-1.5 text-sm font-medium rounded-full flex items-center gap-2 bg-gray-200 text-gray-700">
              <Ban className="w-4 h-4 text-gray-600" />
              Transactions Locked
            </Badge>
          ) : (
            <Badge className="px-4 py-1.5 text-sm font-medium rounded-full flex items-center gap-2 bg-green-100 text-green-700">
              <CheckCircle2 className="w-4 h-4 text-green-600" />
              Transaction Allowed
            </Badge>
          )}
        </div>
      </div>

      {isFiscalDataLoading ? <Loader /> : 
        <>
          {isLocked ? 
            <div className="bg-gray-200 rounded-md px-5 py-3 flex items-start justify-between mb-4">
              <div className="text-sm text-gray-600 leading-relaxed">
                <div>
                  <span className="font-semibold">LOCKED</span> – Closed – Read Only.
                </div>
              </div>
            </div> : 
            isValidationCompleted ? <></> : <div className="bg-red-50 rounded-md px-6 py-1 flex items-start justify-between mb-4">
              <div className="text-sm text-red-600 leading-relaxed">
                <div>
                  <span className="font-semibold">OPEN</span> – Open issues detected. Fix validations.
                </div>
                <div>
                  Transactions may be restricted based on validation cockpit outcomes.
                </div>
              </div>
              <AlertCircle className="w-5 h-5 text-red-500 mt-3" />
            </div>
          }
          <div className="flex flex-col gap-6 w-full">
            {/* Validation Cockpit */}
            <ValidationCockpit setIsValidationCompleted={setIsValidationCompleted} />
            {/* Financial Health */}
            <FinancialHealth />

            {/* Actions */}
            <Actions isValidationCompleted={isValidationCompleted} />

            {/* Audit Log Accordion */}
            <AuditLog />
          </div>
        </>}
    </div>
  );
};

export default FiscalYearClosing;
